var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7071 8.29289C25.0976 8.68342 25.0976 9.31658 24.7071 9.70711L14.7071 19.7071C14.3166 20.0976 13.6834 20.0976 13.2929 19.7071L8.29289 14.7071C7.90237 14.3166 7.90237 13.6834 8.29289 13.2929C8.68342 12.9024 9.31658 12.9024 9.70711 13.2929L14 17.5858L23.2929 8.29289C23.6834 7.90237 24.3166 7.90237 24.7071 8.29289Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7071 8.29289C20.0976 8.68342 20.0976 9.31658 19.7071 9.70711L14.7071 14.7071C14.3166 15.0976 13.6834 15.0976 13.2929 14.7071C12.9024 14.3166 12.9024 13.6834 13.2929 13.2929L18.2929 8.29289C18.6834 7.90237 19.3166 7.90237 19.7071 8.29289ZM3.29289 13.2929C3.68342 12.9024 4.31658 12.9024 4.70711 13.2929L9.70711 18.2929C10.0976 18.6834 10.0976 19.3166 9.70711 19.7071C9.31658 20.0976 8.68342 20.0976 8.29289 19.7071L3.29289 14.7071C2.90237 14.3166 2.90237 13.6834 3.29289 13.2929Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecks);
export default __webpack_public_path__ + "static/media/checks.dc3df507961e48c6275ae98947160d4f.svg";
export { ForwardRef as ReactComponent };